module.exports = __webpack_public_path__ + "static/media/icon-linkedin.41b0f0c5.svg";